const download_app = {
  disfruta_mejor_experiencia:
    '¡Disfruta de una mejor experiencia móvil descargando la aplicación!',
  escanear_para_descargar_en: 'Escanear para descargar en',
  disponible_en_playStore: 'Disponible en PlayStore',
  disponible_en_appStore: 'Disponible en AppStore',
}

export default download_app
